var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExportFileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.131,
    height: 21.263,
    viewBox: "0 0 19.131 21.263",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "export-file",
    d: "M22.052,16.48a1.223,1.223,0,0,0-.223-.351L18.639,12.94a1.067,1.067,0,0,0-1.51,1.51l1.382,1.371H12.568a1.063,1.063,0,1,0,0,2.126h5.943l-1.382,1.371a1.067,1.067,0,1,0,1.51,1.51l3.189-3.189a.989.989,0,0,0,.223-.351,1.063,1.063,0,0,0,0-.808Zm-7.357,4.657H6.189a1.063,1.063,0,0,1-1.063-1.063V5.189A1.063,1.063,0,0,1,6.189,4.126h5.316V7.316a3.189,3.189,0,0,0,3.189,3.189h4.253A1.07,1.07,0,0,0,19.7,8.687L13.323,2.308a1.138,1.138,0,0,0-.3-.2h-.1L12.632,2H6.189A3.189,3.189,0,0,0,3,5.189V20.073a3.189,3.189,0,0,0,3.189,3.189h8.505a1.063,1.063,0,1,0,0-2.126ZM13.631,5.625l2.754,2.754h-1.69a1.063,1.063,0,0,1-1.063-1.063Z",
    transform: "translate(-3 -2)",
    fill: "#00d297"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportFileIcon);
export default __webpack_public_path__ + "static/media/export_file_icon.f0725161505daa0784c97fefa2922a58.svg";
export { ForwardRef as ReactComponent };